import type { ContactItem } from '~/utils/interface'
import { CONTACT_TYPE } from '~/constants'

export const contactUs: ContactItem = {
  title: 'Live chat',
  label: '',
  link: '',
  type: CONTACT_TYPE.LIVECHAT,
  isNewTab: false,
  img: '/assets/images/icons/icon-live-chat.png'
}
